import { language as hint_language } from "./hint";
import { language as content_language } from "./content";
import { language as filePreviewModel_language } from "./file-preview-modal.controller";
import { language as fileLibrarySort_language } from "./file-library-sort-filter-configs";

let language = {
    ...hint_language,    
    ...content_language,
    ...filePreviewModel_language,
    ...fileLibrarySort_language
};

export { language }